exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-autosize[data-v-6a896d4e]{max-height:400px!important;-webkit-transition:height .4s ease;transition:height .4s ease}", ""]);

// exports
